import React from 'react';
import { Card, Form, Input, Radio } from 'antd';
import { isEmpty } from 'script/common';

export const formItemLayout = { labelCol: { span: 3 }, wrapperCol: { span: 20 } } ;

export const RadioComponent = ({t, option, setOption}) => {
	const onChange = (e) => {
		setOption(e.target.value)
	}

	return (
		<Form.Item name='option' style={{ margin: 20 }}>
			<Radio.Group value={option} onChange={onChange}>
				<Radio value={true}> {t('settings.customize.inherited')} </Radio>
				<Radio value={false}> {t('settings.customize.customized')} </Radio>
			</Radio.Group>
		</Form.Item>
	)
}

export const RadioListComponent = ({t, option, optionList, setOption}) => {
	const onChange = (e) => {
		let setValue = optionList.filter((data) => data.value === e.target.value)[0]
		setOption(setValue)
	}

	return (
		<Form.Item name='option' style={{ margin: 20 }}>
			<Radio.Group value={option.value} onChange={onChange}>
				{optionList.map((opt) => {
					return <Radio key={opt.key} value={opt.value}> {t(opt.key)} </Radio>
				})}
			</Radio.Group>
		</Form.Item>
	)
}

export const DataComponent = ({nodes}) => {
	return (
		<div>
			{ isEmpty(nodes) ? null : 
				<Form.Item 
					label='Nodes'
					name={['data', nodes, 'value']}
					rules={[{ required: true, message: 'Please input value!' }]}>
					<Input />
				</Form.Item>
			}
		</div>
	)
}

export const DataTypeSingleMulti = ({t, label, option, apps, settingData, invalid}) => {
	const single = () => {
		return (
			<Card type="inner" title="Common" style={{ margin: 20 }}>
				<Form.Item 
					label={label}
					name={['single', 'value']}
					rules={[{ required: true, message: 'Please input value!'}]}
				>
					<Input placeholder={settingData.single.default}/>
				</Form.Item>
			</Card>
		)
	}

	const multi = () => {
		let singleDefault = null;
		let singleValue = null;
		let multiDefault = null;

		if (!isEmpty(settingData.single)) {
			singleDefault = settingData.single.default;
			singleValue = settingData.single.value;
			multiDefault = (singleDefault === singleValue) ? singleDefault : singleValue;
		}

		return apps.map((app, i) => {

			if (!isEmpty(settingData.multi)) {
				if (!isEmpty(settingData.multi[app.value])) {
					multiDefault = settingData.multi[app.value].default
				}
			}

			return (
				<Card type="inner" key={app.key} title={t(app.key)} style={{ margin: 20 }}>
					<Form.Item 
						label={label}
						name={(['multi', app.value, 'value'])}
						rules={[{ required: invalid, message: 'Please input value!' }]}
					>
						<Input placeholder={multiDefault}/>
					</Form.Item>
				</Card>
			)
		})
	}
		
	return (
		<div>
			{ option ? single() : multi() }			
		</div>
	)
}